import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  pageHeader: {
    padding: "0 0 24px 0px",
  },
  container: {
    margin: 0,
    padding: 0,
    maxWidth: "100%",
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    padding: "0 0 0 12px",
    margin: "0px",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginBottom: "20px",
    },
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "24px",
    padding: "0 0 0 12px",
    marginTop: "4px",
    marginBottom: 0,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      marginBottom: "15px",
    },
  },
  btnWrapper: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "block",
    },
  },
  addBtn: {
    minHeight: "40px",
    "& span": {
      whiteSpace: "nowrap",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      display: "flex",
      justifyContent: "center",
    },
  },
}));

export default styles;
